import React, { JSX } from 'react';
import useConfig from '../../../Hooks/useConfig';
import { MapConfig } from './MapsInterfaces';
const GoogleMaps = React.lazy(() => import('./GoogleMaps'));
const LeafletMap = React.lazy(() => import('./LeafletMap'));

export const MapsWrapper = (
  props: MapConfig & { containerHeight?: string; googleMapsOptions?: { [key: string]: unknown } }
): JSX.Element => {
  const config = useConfig();
  const {
    centerMap,
    zoomMap,
    markers,
    containerHeight,
    mapRef,
    ExtendedMapMarkerPopup,
    zoomSnap,
    pad,
    ignoreBounds,
    googleMapsOptions
  } = props;
  if (config.googleApiKey === '') {
    return (
      <LeafletMap
        containerHeight={containerHeight}
        centerMap={centerMap}
        zoomMap={zoomMap}
        markers={markers}
        mapRef={mapRef}
        pad={pad}
        zoomSnap={zoomSnap}
        ignoreBounds={ignoreBounds}
        ExtendedMapMarkerPopup={ExtendedMapMarkerPopup}
      />
    );
  }
  return (
    <GoogleMaps
      centerMap={centerMap}
      zoomMap={zoomMap}
      markers={markers}
      containerHeight={containerHeight}
      googleMapsOptions={googleMapsOptions}
    />
  );
};
export default MapsWrapper;
